import {Component, inject} from '@angular/core';
import {AuthenticationService} from "@services";
import {ArtworkService, EvaluationService, MediaService} from "@api-services";
import {watchParam} from "@utils";
import {rxResource} from "@angular/core/rxjs-interop";
import {MediaRenderComponent} from "../../../../../components/media-render/media-render.component";
import {map} from "rxjs/operators";
import {TranslocoDirective} from "@jsverse/transloco";
import {CurrencyPipe} from "@angular/common";
import {ButtonComponent} from "@components";
import {WINDOW} from "../../../../../injector";

@Component({
  selector: 'wun-evaluation-details',
  standalone: true,
  imports: [
    MediaRenderComponent,
    TranslocoDirective,
    CurrencyPipe,
    ButtonComponent
  ],
  templateUrl: './evaluation-details.component.html',
  styleUrl: './evaluation-details.component.scss'
})
export class EvaluationDetailsComponent {

  private readonly evaluationService = inject(EvaluationService);
  private readonly artworkService = inject(ArtworkService);
  private readonly id = watchParam('id', Number)
  private readonly mediaService = inject(MediaService)
  private readonly window = inject(WINDOW)


  artwork = rxResource({
    params: this.id,
    stream: p => this.artworkService.artworksFindAndPaginate({
      filters: JSON.stringify({
        evaluation: p.params
      }),
      includes: JSON.stringify(['evaluation', 'mainAttachment'])
    }).pipe(
      map(d => d.data[0])
    )
  })

  downloadReport() {
    this.mediaService.mediaGetSignedUrl({
      id: this.id()!
    }).subscribe(f => {
      this.window.open(f[0], '_blank');
    })
  }

  acceptEvaluation() {
    this.evaluationService.evaluationsAccept({
      id: this.id()!
    }).subscribe(
      f => {
        this.artwork.reload()
      }
    )
  }

  rejectEvaluation() {
    this.evaluationService.evaluationsReject({
      id: this.id()!
    }).subscribe(f => {
      this.artwork.reload()
    })
  }
}
